import useActionsNewspaperAdvancedSettingForm from './useActionsNewspaperAdvancedSettingForm'

export default useActionsNewspaperAdvancedSettingForm
